import { jsx as s } from "react/jsx-runtime";
import { useMemo as r } from "react";
import { composeIDSTableColumnDefs as p } from "./helpers/composeIDSTableColumnDefs.js";
import { u as f } from "../../index-CtOScEKX.js";
import { composeIDSTableInitialSorting as g } from "./helpers/composeIDSTableInitialSorting.js";
import { getTableContext as d } from "./TableContext.js";
import { findColumnByKey as c } from "./helpers/findColumnByKey.js";
import { g as u, a as S } from "../../index-CmsyHM_3.js";
const I = ({
  children: i,
  columns: o,
  rows: e
}) => {
  const m = r(() => p(e, o), [o, e]), t = f({
    columns: m,
    data: e,
    getCoreRowModel: S(),
    getSortedRowModel: u(),
    initialState: {
      sorting: g(o)
    }
  }), a = r(
    () => ({
      api: t,
      getColumnByKey: (l) => c(l, o)
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only update when columns and rows change
    [e, o, t.getState().sorting]
  ), { Provider: n } = d();
  return /* @__PURE__ */ s(n, { value: a, children: i });
};
export {
  I as IressTableProvider
};
